module.exports = __webpack_public_path__ + "static/media/video-slash.1c8c7906.svg";